import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';

export interface Titles {
  title: string;
  subtitle: string;
}

const titles = {
  title: '',
  subtitle: ''
};

export interface BusinessUnit {
  id: string;
  fullid: string;
  subtitle: string;
  title: string;
  measureId?: string;
  rangecolor?: string;
  titleUrl?: string;
}

const businessUnits: BusinessUnit[] = [];

export interface CorporateBusinessCanvasState {
  titles: Titles;
  businessUnits: BusinessUnit[];
  error: ErrorObject;
}

const initialState = {
  titles,
  businessUnits,
  error: { message: '', details: '' }
} as CorporateBusinessCanvasState;

export default initialState;
